module.exports = __webpack_public_path__ + "img/slide8.e6aeb67f.png";